import http from "./httpService";
import { useContext } from "react";
import { ConfigContext } from "./../context/ConfigContext";
import { showProgressBar } from "../services/uiService";
import { hideProgressBar } from "../services/uiService";
import { isBrowser, isMobile } from "react-device-detect";

export async function forgotPasswordEmail(usersEndPoint, userName) {
  console.log("FORGOT PWD=", userName + "=");
  var result = null;
  try {
    result = await http.post(usersEndPoint + "/forgotpwd", {
      UserName: userName,
      Password: "xxx",
    });
  } catch (ex) {
    console.log("authService.forgotPasswordEmail error: " + ex);
  }
  return result;
}

export async function resetPassword(usersEndPoint, uid, sid, pwd) {
  console.log("resetPassword=", uid + "=");
  var result = null;
  try {
    result = await http.post(usersEndPoint + "/resetpwd", {
      UID: uid,
      SID: sid,
      PWD: pwd,
    });
  } catch (ex) {
    console.log("authService.resetPassword error: " + ex);
  }
  return result;
}

export async function logout(usersEndPoint, sessionID) {
  var result = null;
  try {
    result = await http.get(
      usersEndPoint + "/logout?userSessionID=" + sessionID
    );
    /*result = await http.get(usersEndPoint + "/logout", {
      userSessionID: sessionID,
    });*/
  } catch (ex) {
    console.log("authService.logout error: " + ex);
  }
  return result;
}

export async function devLogin(generalEndPoint) {
  let result = null;
  try {
    result = await http.post(generalEndPoint + "/Auth/dev-login", {});
  } catch (ex) {
    // Re-throw 404 errors so caller can handle them (treat as PROD mode)
    if (ex?.response?.status === 404) {
      throw ex;
    }
    console.log("authService.devLogin error: " + ex);
  }
  return result;
}

export async function login(usersEndPoint, userName, Password, obj) {
  var result = null;
  try {
    result = await http.post(usersEndPoint + "/login", {
      UserName: userName,
      Password: Password,
    });
  } catch (ex) {
    console.log("authService.login error: " + ex);
  }
  return result;
}

export async function logintk(
  usersEndPoint,
  NationalIdOrFullName,
  CellularOrEmail,
  IdentityUserBy,
  TokenTargetType
) {
  //console.log("NationalIdOrFullName=" + NationalIdOrFullName.trim() + "=");
  //console.log("CellularOrEmail=" + CellularOrEmail.trim() + "=");
  //console.log("IdentityUserBy=" + IdentityUserBy + "=");
  //console.log("TokenTargetType=" + TokenTargetType + "=");

  var result = null;
  try {
    result = await http.post(usersEndPoint + "/logintk", {
      NationalIdOrFullName: NationalIdOrFullName.trim(),
      CellularOrEmail: CellularOrEmail.trim(),
      IdentityUserByVal: IdentityUserBy,
      TokenTargetTypeVal: TokenTargetType,
    });
  } catch (ex) {
    console.log("authService.logintk error: " + ex);
  }
  return result;
}

export async function resendtk(
  usersEndPoint,
  NationalIdOrFullName,
  CellularOrEmail,
  IdentityUserBy,
  TokenTargetType,
  TmpSessionId
) {
  console.log("NationalIdOrFullName=" + NationalIdOrFullName.trim() + "=");
  console.log("CellularOrEmail=" + CellularOrEmail.trim() + "=");
  console.log("IdentityUserBy=" + IdentityUserBy.trim() + "=");
  console.log("TokenTargetType=" + TokenTargetType.trim() + "=");
  console.log("TmpSessionId=" + TmpSessionId.trim() + "=");

  var result = null;
  try {
    result = await http.post(usersEndPoint + "/resendtk", {
      NationalIdOrFullName: NationalIdOrFullName.trim(),
      CellularOrEmail: CellularOrEmail.trim(),
      IdentityUserByVal: IdentityUserBy.trim(),
      TokenTargetTypeVal: TokenTargetType.trim(),
      TmpSession: TmpSessionId.trim(),
    });
  } catch (ex) {
    console.log("authService.resendtk error: " + ex);
  }
  hideProgressBar();
  return result;
}

export async function verifytk(
  usersEndPoint,
  NationalIdOrFullName,
  CellularOrEmail,
  IdentityUserBy,
  TokenTargetType,
  VerificationCode,
  TmpSession
) {
  console.log(
    "verifytk : NationalIdOrFullName=" + NationalIdOrFullName.trim() + "="
  );

  showProgressBar();

  console.log("verifytk : CellularOrEmail=" + CellularOrEmail.trim() + "=");
  console.log("verifytk : IdentityUserBy=" + IdentityUserBy + "=");
  console.log("verifytk : TokenTargetType=" + TokenTargetType + "=");
  console.log("verifytk : VerificationCode=" + VerificationCode + "=");
  console.log("verifytk : TmpSession =" + TmpSession + "=");

  var result = null;
  try {
    result = await http.post(usersEndPoint + "/verifytk", {
      NationalIdOrFullName: NationalIdOrFullName.trim(),
      CellularOrEmail: CellularOrEmail.trim(),
      IdentityUserByVal: IdentityUserBy,
      TokenTargetTypeVal: TokenTargetType,
      VerificationCode: VerificationCode,
      TmpSession: TmpSession,
    });
  } catch (ex) {
    console.log("authService.verifytk error: " + ex);
  }
  hideProgressBar();
  return result;
}
